import { useMemo } from "react";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import { useGlobalManualLocationOrder } from "../../../../contexts/Staffing/GlobalManualLocationOrderContext";
import { getUniqueLocationNames } from "../../../../utils/utilFunctions";
import type { GapsLocationEntry } from "../gapsDayModel";
import { otherUnitsForChange } from "../gapsGroupSheets";

/**
 * The department's units outside the group's own, in its location order — with the group's, every unit the desktop
 * location editor offers (`getUniqueLocationNames`). Both phone unit pickers (Change location, Assign unit) list them,
 * so a window whose config names no units still offers the department's.
 */
export const useGapsOtherUnits = (groupUnits: readonly GapsLocationEntry[]): string[] => {
	const { chosenDepartment } = useHospitalData();
	const { customStringOrderMap } = useGlobalManualLocationOrder();
	return useMemo(
		() => otherUnitsForChange(getUniqueLocationNames(chosenDepartment.locations), groupUnits, customStringOrderMap),
		[chosenDepartment.locations, groupUnits, customStringOrderMap],
	);
};
